import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { LOCALES, dict } from './dict'

const Ctx = createContext(null)
const KEY = 'kx.locale'

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => localStorage.getItem(KEY) || 'id')
  const meta = LOCALES.find((l) => l.code === locale) || LOCALES[0]

  useEffect(() => {
    localStorage.setItem(KEY, locale)
    document.documentElement.lang = locale
    document.documentElement.dir = meta.dir
  }, [locale, meta.dir])

  const t = useCallback((key, vars) => {
    let s = dict[locale]?.[key] ?? dict.id[key] ?? key
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v) })
    return s
  }, [locale])

  /** Pick the right name_* field off a category-ish record. */
  const localized = useCallback((obj, base = 'name') => obj?.[`${base}_${locale}`] || obj?.[`${base}_id`] || obj?.[base] || '', [locale])

  const value = useMemo(() => ({ locale, setLocale, t, localized, dir: meta.dir, locales: LOCALES }), [locale, t, localized, meta.dir])
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export const useI18n = () => {
  const v = useContext(Ctx)
  if (!v) throw new Error('useI18n must be used inside I18nProvider')
  return v
}
